import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TeamStore as MobxTeamStore } from 'nomst/Stores/team.store';
import { changeHistoryStore } from 'utils/MobxDataManager/singletons';
import { ChangeHistoryContainerView } from 'nomst/Components/ChangeHistory/changeHistoryContainerView';
import { ChangeHistoryContainer } from 'nomst/Stores/ChangeHistory/changeHistoryContainer';
import { ReportsView } from 'typings/enums';
import ManagerListSidePanel from 'nomst/Components/Decision/ManagerListSidePanel/managerListSidePanel';
import './changeHistoryView.scss';

export interface IChangeHistoryViewProps {
    store: MobxTeamStore;
}

export class ChangeHistoryView extends React.Component<IChangeHistoryViewProps> {
    constructor(props: IChangeHistoryViewProps) {
        super(props);
        this.goToManagerView = this.goToManagerView.bind(this);
    }

    render(): React.ReactNode {
        const { isLoading, changeHistoryContainers } = changeHistoryStore;

        if (isLoading) {
            return null;
        }

        if (!changeHistoryContainers || changeHistoryContainers.length === 0) {
            return this.renderEmptyChangeHistoryState();
        }

        return (
            <div className="manager-list-open">
                {this.renderSidePanel()}
                <div className="nomst-change-history">
                    <div className="link-icon">
                        <span>
                            {this.renderReturnToTeamView()}
                        </span>
                    </div>
                    {this.renderTeamName()}
                    {this.renderChangeHistoryContainers(changeHistoryContainers)}
                </div>
            </div>
        );
    }

    private renderSidePanel(): React.ReactNode {
        const { decisionStore, navigationStore, configuration } = this.props.store;
        return (
            <ManagerListSidePanel
                decisionDispatcher={decisionStore.decisionDispatcher}
                navigationStore={navigationStore}
                configuration={configuration}
                budgetNamesMap={decisionStore.budgetNames}
                managerWorkflowStore={decisionStore.managerWorkflowStore}
            />
        );
    }

    private goToManagerView(clickEvent: React.MouseEvent<HTMLButtonElement>): void {
        const { navigationStore, configuration } = this.props.store;
        navigationStore.navigateToWorkflowStatusManagersRoute(
            configuration.cycleId,
            [changeHistoryStore.manager.employeeSourceId],
            null,
            ReportsView.DirectsOnly);

        clickEvent.preventDefault();
    }

    private renderTeamName(): React.ReactNode {
        if (!changeHistoryStore.manager ||
            !changeHistoryStore.manager.displayName) {
            return (<h2>Change History</h2>);
        }

        return (<h2>Change History for {changeHistoryStore.manager.displayName}&apos;s Team</h2>);
    }

    private renderEmptyChangeHistoryState(): React.ReactNode {
        return (
            <div className="nomst-change-history-empty pxl-padding-top-xlarge">
                <img
                    alt=""
                    src={require('contents/icon-change_history.svg')}
                />
                <div className="pxl-margin-top-lg">
                    <p className="pxl-text-c11-6">
                        No Pay Changes Have Been Made
                    </p>
                    <p className="pxl-text-sm pxl-text-c11-6">
                        Pay changes made by reviewers will appear here
                    </p>
                    <span>
                        {this.renderReturnToTeamView()}
                    </span>
                </div>
            </div>
        );
    }

    private renderChangeHistoryContainers(changeHistoryContainers: ChangeHistoryContainer[]): React.ReactNode {
        let currency = this.props.store.decisionStore.teamDecisionStore.currentIsoCurrencyCode;
        if (!currency) {
            currency = this.props.store.configuration.homeCountryCurrency;
        }

        return changeHistoryContainers.map((changeHistoryContainer, index) => {
            return (
                <ChangeHistoryContainerView
                    configuration={this.props.store.configuration}
                    navigationStore={this.props.store.navigationStore}
                    key={index}
                    changeHistoryContainer={changeHistoryContainer}
                    selectedCurrency={currency}
                />
            );
        });
    }

    private renderReturnToTeamView(): React.ReactNode {
        return (
            <button className="change-history__return pxl-link" onClick={this.goToManagerView}>
                <i className="icon-reply" /><span className="change-history__return-text">Return to Team View</span>
            </button>
        );
    }
}

export default inject('store')(observer(ChangeHistoryView));